import React from 'react'
import PropTypes from 'prop-types'
import {Card, CardBody, CardHeader} from 'reactstrap'
import ImportItemsTable from './ImportItemsTable'

class ImportItemsView extends React.Component {
    render() {
        const {items, ...rest} = this.props

        return (
            <div className='ImportItemsView mt-3'>
                <Card>
                    <CardHeader>
                        <h4 className='d-flex justify-content-between align-items-center w-100 font-weight-bold mb-3'>
                            <div>Output</div>
                        </h4>
                    </CardHeader>
                    <CardBody>
                        <ImportItemsTable {...rest} items={items}/>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

ImportItemsView.propTypes = {
    items: PropTypes.array.isRequired
}

export default ImportItemsView
